// extracted by mini-css-extract-plugin
export default {"containerTable":"vehicleDetails_containerTable__8H+in"};